module.exports = __webpack_public_path__ + "img/terroir-tinted-3.626e33ef.jpg";